import {
  ArrowsPointingInIcon,
  ChevronDownIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import Confirm from "./Confirm";
import ModalInput from "./Inputs/ModalInput";
import Input from "./Inputs/Input";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  horizontalListSortingStrategy,
  SortableContext,
} from "@dnd-kit/sortable";

import SortableItem from "src/components/Sortable/SortableItem";
import ScenarioTab from "src/components/ScenarioTab";
import { Fragment, useState } from "react";
import { printReport } from "src/utils";
import { useInfo } from "src/hooks/useData";
import { useFullscreen } from "src/hooks/useFullScreen";
import { Tooltip } from "flowbite-react";
import { Dialog, Listbox, Transition } from "@headlessui/react";
import { Client } from "src/types";
import { useUser } from "src/hooks/useUser";
import ReportTemplateModal from "./ReportTemplate/ReportTemplateModal";
import Spinner from "./Spinner";

const Scenarios = ({ tab, setTab }: any) => {
  const { user } = useUser();
  const {
    data,
    setField,
    setLocal,
    deleteScenario,
    updateScenario,
    saveScenario,
  } = useInfo();
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    const oldIndex = scenarios.findIndex((s) => s.id === active.id);
    const newIndex = scenarios.findIndex((s) => s.id === over.id);
    if (oldIndex !== newIndex) {
      console.log(arrayMove([...scenarios], oldIndex, newIndex));

      setField("scenarioOrder")(
        arrayMove([...scenarios], oldIndex, newIndex).map((i) => i.id),
      );
      setLocal((data: Client) => ({
        ...data,
        scenarios: arrayMove([...scenarios], oldIndex, newIndex),
      }))();
      // storeScenarios(arrayMove([...scenarios], oldIndex, newIndex));
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );
  const print = async (report: any) => {
    setPrinting(true);
    // const url = await printReport(data.id, tab, report);
    const url = await printReport(data.id, tab, report.settings);
    setPrinting(false);
    window.open(url, "_blank");
  };

  const scenarios = data.scenarios;

  const { isFullscreen, toggleFullscreen } = useFullscreen();

  const [saveOpen, setSaveOpen] = useState(false);
  const [name, setName] = useState("");
  const [reportTemplateOpen, setReportTemplateOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState<string | null>(null);

  const addScenario = (newData: any) => {
    saveScenario({ ...newData, id: Math.round(Math.random() * 10000000) });
  };
  const removeScenario = () => {
    deleteScenario(tab);
    setTab(scenarios[0].id);
  };

  const copyScenario = () => {
    setSaveOpen(false);
    const currentScenario = scenarios.find((item) => item.id === tab);
    if (currentScenario) {
      addScenario({
        ...currentScenario,
        name,
      });
    }
  };
  const [removeOpen, setRemoveOpen] = useState(false);
  const [printing, setPrinting] = useState(false);

  const currentScenario = scenarios.find((item) => item.id === tab);
  let nextName = "";
  if (currentScenario) {
    const match = currentScenario.name.match(/^(.*?)( \((\d+)\))?$/);

    if (!match) return currentScenario.name + " (1)";

    const baseName = match[1];
    const currentIndex = match[3] ? parseInt(match[3], 10) : 0;

    nextName = `${baseName} (${currentIndex + 1})`;
  }
  return (
    <div
      className={`flex justify-between items-center print:hidden bg-white sticky z-5000 ${
        isFullscreen ? "top-[80px]" : "top-[151px]"
      } bg-[#f3f4f6]`}
    >
      <Transition appear show={printing} as={Fragment}>
        <Dialog as="div" className="relative z-100000" onClose={() => false}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-0" />
          </Transition.Child>

          <div
            className="fixed inset-0 overflow-y-auto"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="transform bg-white p-6 shadow-xl transition-all rounded-xl w-96">
                  <div className="flex flex-col gap-4">
                    <div className="text-2xl font-semibold">
                      Generating PDF report...
                    </div>
                    <Spinner />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={scenarios}
          strategy={horizontalListSortingStrategy}
        >
          <div className="flex mt-[-4px] max-w-[1200px] overflow-y-scroll">
            {scenarios.map((sc, i) => (
              <SortableItem key={sc.id} id={sc.id} onClick={() => setTab(i)}>
                <ScenarioTab
                  name={sc.name}
                  active={tab == sc.id}
                  setActive={() => setTab(sc.id)}
                  id={i}
                  store={(name: string) => {
                    updateScenario(sc.id, {
                      name,
                    });
                  }}
                />
              </SortableItem>
            ))}
          </div>
        </SortableContext>
      </DndContext>
      <div>
        <div className="flex justify-end print:hidden">
          <div className="print:hidden">
            <div className="flex gap-3 p-3">
              <div
                className="flex items-center"
                onClick={() => toggleFullscreen()}
              >
                {isFullscreen ? (
                  <ArrowsPointingInIcon className="h-6 w-6" />
                ) : (
                  <img
                    src="/icons/expand.png"
                    className="h-6 w-6 cursor-pointer"
                  />
                )}
              </div>
            </div>
          </div>
          <div>
            <Listbox value={null}>
              <div className="relative">
                <Listbox.Button
                  className={`flex gap-1 pl-3 text-left justify-between mt-[13px] cursor-pointer`}
                >
                  <img src="/icons/print.png" className="h-6 w-6 " />
                  <span className="flex items-center pr-2">
                    <ChevronDownIcon
                      className={`h-5 w-5 text-gray-400 `}
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <div className="relative">
                  <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Listbox.Options
                      className={`absolute right-0 mt-1 max-h-96  overflow-y-auto rounded-lg bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none  z-50000 `}
                    >
                      {user?.reportTemplates.map(
                        (person: any, personIdx: number) => (
                          <Listbox.Option
                            key={personIdx}
                            className={({ active }) =>
                              `relative cursor-default min-h-8 select-none py-2 text-left pl-8 z-6000 border-b ${
                                active ? "" : "text-gray-900"
                              }`
                            }
                            value={person}
                          >
                            {({ selected }) => (
                              <div className="flex justify-between items-center whitespace-nowrap gap-10 mr-8">
                                <div
                                  className={`block  ${
                                    selected
                                      ? "font-medium"
                                      : "font-normal w-full"
                                  }`}
                                >
                                  {person.name}
                                </div>
                                <div className="flex gap-2">
                                  <img
                                    src="/icons/print.png"
                                    className="h-8 w-8 cursor-pointer rounded-md p-1 border-2 hover:border-main-orange"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      print(person);
                                    }}
                                  />
                                  <PencilIcon
                                    className="h-8 min-w-8 inline ml-2 cursor-pointer border-2 p-1 rounded-md hover:border-main-orange"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditingTemplate(person.id);
                                      setReportTemplateOpen(true);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </Listbox.Option>
                        ),
                      )}
                      <Listbox.Option
                        value={1}
                        className={({ active }) =>
                          `relative cursor-default min-h-8 select-none py-2 text-left pl-3 z-6000  mt-2 ${
                            active
                              ? " text-main-orange bg-[rgba(var(--primary-color-segment),0.1)]"
                              : "text-gray-900"
                          }`
                        }
                        onClick={() => {
                          setReportTemplateOpen(true);
                          setEditingTemplate("custom");
                        }}
                      >
                        {({ selected }) => (
                          <>
                            <div
                              className={`block  ${
                                selected
                                  ? "font-medium"
                                  : "font-normal w-full min-w-[200px]"
                              }`}
                            >
                              <Cog6ToothIcon className="h-5 w-5 inline mr-2" />
                              Custom Report
                            </div>
                            {selected ? (
                              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                {/*<CheckIcon className="h-5 w-5" aria-hidden="true" />*/}
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    </Listbox.Options>
                  </Transition>
                </div>
              </div>
            </Listbox>
          </div>

          {
            <div>
              <div
                className="flex gap-2 p-3 cursor-pointer"
                onClick={() => {
                  setName(nextName);
                  setSaveOpen(true);
                }}
              >
                <Tooltip
                  content={"Create a copy of this scenario"}
                  style="dark"
                  placement="bottom"
                  className="z-50000! bg-gray-900"
                >
                  <DocumentDuplicateIcon className="h-6 w-6 text-gray-800 cursor-pointer" />
                </Tooltip>
              </div>
              <ModalInput
                isOpen={saveOpen}
                onClose={() => {
                  setSaveOpen(false);
                  setName("");
                }}
                onConfirm={() => {
                  copyScenario();
                }}
              >
                <div className="py-3">
                  <div className="text-lg font-semibold mb-2">
                    New Scenario Name:
                  </div>
                  <Input
                    label=""
                    value={name}
                    setValue={(name) => setName(name)}
                    onKeyDown={(e: any) => {
                      if (e.key === "Enter") {
                        copyScenario();
                      }
                    }}
                    size="full"
                    vertical
                  />
                </div>
              </ModalInput>
            </div>
          }
          {scenarios.length > 1 && (
            <div>
              <TrashIcon
                className="h-6 w-6 text-red-500 cursor-pointer m-3"
                onClick={() => setRemoveOpen(true)}
              />
            </div>
          )}
          <Confirm
            isOpen={removeOpen}
            onClose={() => setRemoveOpen(false)}
            onConfirm={() => {
              if (removeScenario) removeScenario();
              setRemoveOpen(false);
            }}
          >
            <TrashIcon className="text-slate-400 w-10 m-auto mb-5" />
            <div className="mb-5">
              Are you sure you want to delete this scenario?
            </div>
          </Confirm>
        </div>
      </div>
      <ReportTemplateModal
        setPrinting={setPrinting}
        open={reportTemplateOpen}
        setOpen={setReportTemplateOpen}
        initialEditing={editingTemplate}
        onClose={() => {
          setReportTemplateOpen(false);
          setEditingTemplate(null);
        }}
        clientData={data}
        scenarioData={scenarios.find((s) => s.id === tab)}
      />
    </div>
  );
};

export default Scenarios;
